import { render, staticRenderFns } from "./Gem.vue?vue&type=template&id=4c54d7a6&"
import script from "./Gem.vue?vue&type=script&lang=js&"
export * from "./Gem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports